import React from 'react'
import ReactDOM from 'react-dom/client'
import { ApolloProvider } from '@apollo/client'
import { client } from './apollo'
import { AppRoute } from './app/shared/Services/AppRoute'
import { ToastProvider } from './app/shared/components/Toast'

import './styles/tokens.css'
import './styles/maestro/bundle.css'
import './index.scss'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <ToastProvider>
        <AppRoute></AppRoute>
      </ToastProvider>
    </ApolloProvider>
  </React.StrictMode>,
)
